<div id="side-page">
    <div>
        <button class="entity-btn" mat-button [matMenuTriggerFor]="menu">
            <span>Portail | </span>
            <span class="np-color">{{selectedEntity.label}}</span>
            <span class="material-icons">apps</span>
        </button>
    </div>
    <mat-menu #menu="matMenu" class="entity-menu">
        <mat-list>
            <div mat-subheader class="entity-menu-title np-color">Portails disponibles</div>
            <mat-selection-list [multiple]="false">
                <mat-list-option
                        *ngFor="let entity of entities"
                        [value]="entity"
                        (click)="changeEntity(entity)"
                        [selected]="entity.name === selectedEntity?.name"
                        [attr.title]="entity.description"
                        color="primary"
                >
                    <span class="material-icons" matListItemIcon>perm_media</span>
                    {{entity.label}}
                </mat-list-option>
            </mat-selection-list>
<!--            <mat-divider></mat-divider>-->
<!--            <div mat-subheader class="entity-menu-title np-color">Aller plus loin (à proposer à Renaud)</div>-->
<!--            <mat-list role="list">-->
<!--                <mat-list-item role="listitem">Accéder à NEXTPAGE@</mat-list-item>-->
<!--                <mat-list-item role="listitem">Consulter notre FAQ</mat-list-item>-->
<!--                <mat-list-item role="listitem">Lire les mentions légales</mat-list-item>-->
<!--            </mat-list>-->
<!--            <mat-divider class="my-3"></mat-divider>-->
<!--            <div mat-subheader class="entity-menu-title np-color">Administration</div>-->
<!--            <mat-list role="list">-->
<!--                <mat-list-item role="listitem">Ajouter un client</mat-list-item>-->
<!--                <mat-list-item role="listitem">Visualiser tous les clients</mat-list-item>-->
<!--            </mat-list>-->
        </mat-list>
    </mat-menu>
    <mat-divider class="my-3"></mat-divider>
    <ul class="list-group">
        <li *ngFor="let menuItem of menuItems$ | async"
            class="list-group-item gap-container-2 btn btn-primary"
            [ngClass]="{active: menuItem.selected}"
            (click)="menuItem.action();
             setActiveItem(menuItem)">
            <span class="material-icons" matListItemIcon>{{menuItem.iconName}}</span>
            <span>{{menuItem.label}}</span>
        </li>
    </ul>
</div>
